import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ErrorModule } from 'src/app/components/error/error.module';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { IconsModule } from 'src/app/icons/icons.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { DatepickerModule } from 'src/app/components/datepicker/datepicker.module';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { QuestionnaireSummaryComponent } from './questionnaire-summary.component';

@NgModule({
  declarations: [
    QuestionnaireSummaryComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatDatepickerModule,
    MatInputModule,
    MatChipsModule,
    MatAutocompleteModule,
    ErrorModule,
    IconsModule,
    DatepickerModule,  ],
  exports: [
    QuestionnaireSummaryComponent
  ]
})
export class QuestionnaireSummaryModule { }
